
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaProduto: [],
	listaDistribuidora: [],
	filtro: {
		data: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	}
};


export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PRECO_DIA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
		
		case 'PRECO_DIA_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

		case 'PRECO_DIA_FILTRO':
            return { ...state,
				filtro: action.payload
			};

        case 'PRECO_DIA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        case 'PRECO_DIA_PRODUTO_SELECT_LISTADO':
            return {
				...state,
				listaProduto: action.payload.data
			};

        case 'PRECO_DIA_DISTRIBUIDORA_SELECT_LISTADO':
            return {
				...state,
				listaDistribuidora: action.payload.data
			};

        default:
            return state;
    }
}
